import { axios } from '@argon/app/axios'
import { toFilterString, stampItem } from '@argon/app/helpers'

const NAMESPACE = 'groups'
const GROUP_USERS = 'groupUsers'

const state = {
  groups: [],
  currentGroup: {},
  groupsCount: null,
  groupsPagination: {},
  users: {},
  usersPagination: {}
}

const mutations = {
  SET_GROUPS: (state, payload) => {
    state.groups = payload
  },
  SET_GROUP_COUNT: (state, payload) => {
    state.groupsCount = payload
  },
  SET_CURRENT_GROUP: (state, payload) => {
    state.currentGroup = payload
  },
  SET_GROUPS_PAGINATION: (state, payload) => {
    state.groupsPagination = payload
  },
  SET_USERS: (state, payload) => {
    state.users = payload
  },
  SET_USERS_PAGINATION: (state, payload) => {
    state.groupsPagination = payload
  }
}
const actions = {
  listGroups: ({ commit, state, rootState }, { pager }) => {
    let pagerParams = pager || state.groupsPagination
    const filters = toFilterString(rootState.app.appliedFilters[NAMESPACE])
    let params = { filters, ...pagerParams }
    return new Promise((resolve, reject) => {
      axios({
        url: '/groups',
        method: 'GET',
        params
      })
        .then(({ data }) => {
          commit('SET_GROUPS', data.items)
          commit('SET_GROUP_COUNT', data.count)
          commit('SET_GROUPS_PAGINATION', pagerParams)
          resolve(data.items)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  listGroupUsers: ({ commit, state, rootState }, { groupRef, pager }) => {
    let pagerParams = pager || state.usersPagination[groupRef]
    const filters = toFilterString(rootState.app.appliedFilters[GROUP_USERS])
    let params = { include: 'user,account', filters, ...pagerParams }
    return new Promise((resolve, reject) => {
      axios({
        url: `/groups/${groupRef}/users`,
        method: 'GET',
        params
      })
        .then(({ data }) => {
          commit('SET_USERS', { ...state.users, [groupRef]: data })
          commit('SET_USERS_PAGINATION', { ...state.usersPagination, [groupRef]: pagerParams })
          resolve(data.items)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteGroup: ({ dispatch }, groupRef) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/groups/${groupRef}`,
        method: 'DELETE'
      })
        .then(() => {
          dispatch('listGroups', {})
          resolve(true)
        })
        .catch(reject)
    })
  },
  getGroup: ({ commit }, groupRef) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/groups/${groupRef}`,
        params: { include: 'users,user_ids' },
        method: 'GET'
      })
        .then(({ data }) => {
          commit('SET_CURRENT_GROUP', data)
          resolve(data)
        })
        .catch(reject)
    })
  },
  createGroup: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/groups',
        data: payload,
        method: 'POST'
      })
        .then(({ data }) => {
          dispatch('listGroups', {})
          resolve(data)
        })
        .catch(reject)
    })
  },
  addPrincipals: ({ dispatch }, payload) => {
    const { principalIds, attribution, groupRef } = payload
    let promises = principalIds.map((user_id) => {
      let options = {
        url: `/groups/${groupRef}/users`,
        data: { user_id, attribution },
        method: 'POST'
      }
      return axios(options)
    })
    return new Promise((resolve, reject) => {
      Promise.all(promises).then(resolve).catch(reject)
    })
  },
  deletePrincipals: ({ dispatch }, payload) => {
    const { principalIds, groupRef } = payload
    let promises = principalIds.map((id) => axios({ url: `/groups/${groupRef}/users/${id}`, method: 'DELETE' }))
    return new Promise((resolve, reject) => {
      Promise.all(promises).then(resolve).catch(reject)
    })
  },
  updateGroupMembers: ({ commit, dispatch, state }, payload) => {
    const { groupRef, data } = payload
    let url = `/groups/${groupRef}/users/update-userids`
    return new Promise((resolve, reject) => {
      axios({
        url,
        data,
        method: 'POST'
      })
        .then(({ data }) => {
          dispatch('listGroupUsers', { groupRef })
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  clearGroups: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('SET_GROUPS', [])
      resolve(true)
    })
  },
  clearCurrentGroup: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('SET_CURRENT_GROUP', {})
      resolve(true)
    })
  }
}
const getters = {
  groups: (state) => state.groups,
  users: (state) => (id) => state.users[id],
  usersCount: (state) => (id) => state.usersCount[id],
  usersFilters: (state) => (id) => state.usersFilters[id],
  currentGroup: (state) => state.currentGroup
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export { NAMESPACE, GROUP_USERS }
